// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eb7440c1","239":"967dc09d","453":"de5180f0","455":"b59284f1"}[chunkId] + ".chunk.js";
};